// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetMasterCategoryListRequest from "../contract/GetMasterCategoryListRequest";

export default function getMasterCategoryListRequest(data: GetMasterCategoryListRequest): GetMasterCategoryListRequest {
    const result: GetMasterCategoryListRequest = {
        __type: "GetMasterCategoryListRequest:#Exchange",
        ...data,
    };
    
    return result;
}
